
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promocoes/gratis",
      function () {
        return require("private-next-pages/promocoes/gratis.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promocoes/gratis"])
      });
    }
  